import { render, staticRenderFns } from "./settings-wages.vue?vue&type=template&id=221e00ea"
import script from "./settings-wages.vue?vue&type=script&lang=js"
export * from "./settings-wages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports